// extracted by mini-css-extract-plugin
export default {"EditContact":"EditContact_EditContact__kxux5","EditContact-Card":"EditContact_EditContact-Card__xBiUT"};